export function maskEmail(email) {
  if (email && email.trim()) {

    return email
      .split(",") // handle comma-separated emails
      .map((e) => {
        const trimmedEmail = e.trim();

        const atIndex = trimmedEmail.indexOf("@");
        if (atIndex === -1) return trimmedEmail; // invalid email safeguard

        const username = trimmedEmail.slice(0, atIndex);
        const domain = trimmedEmail.slice(atIndex + 1);

        const beforeEmail =
          username.length >= 3
            ? "*".repeat(username.length - 3) + username.slice(-3)
            : username;

        const afterEmail =
          domain.length >= 5
            ? "*".repeat(domain.length - 5) + domain.slice(-5)
            : domain;

        return beforeEmail + "@" + afterEmail;
      })
      .join(", "); // keep clean formatting
  }

  return "";
}

export function maskPhoneNumber(phoneNumber) {
    if (phoneNumber && phoneNumber.trim()) {
      return phoneNumber.length >= 4
        ? "+91 " +
            "*".repeat(phoneNumber.length - 4) +
            phoneNumber.substring(phoneNumber.length - 4)
        : "+91" + phoneNumber;
    }
    return "";
}
